import { liftMeasurement as liftMeasurementPage } from '../configs/tools/shared-library/lift-measurement';

export const liftMeasurement = {
  ...liftMeasurementPage,
  description: _TL_('Lift measurement helps you understand how much more likely consumers are to search for your brand, visit your website, and make purchases after seeing your Audience ads.'),
};
